import React from 'react';
import Text from '@amzn/meridian/text';
import { Status } from '../../../api/Notifications/schema';
import { colorGray500 } from '@amzn/meridian-tokens/base/color';
import Tag from '@amzn/meridian/tag';
import { getTranslatedMoment } from '../../../translations';

const moment = getTranslatedMoment();

interface TitleAndTagProps {
  title: string;
  message: string;
  timestamp?: string;
  status?: Status;
}

export const TitleAndTag: React.FC<TitleAndTagProps> = ({
  title,
  message,
  timestamp,
  status,
}: TitleAndTagProps): React.ReactElement => {
  return (
    <>
      <span style={{ paddingTop: '10px' }}></span>
      <Text tag='span'>
        <span
          style={{
            visibility: status === Status.SENT ? 'visible' : 'hidden',
          }}
        >
          <Tag type='theme' />
        </span>
        <span style={{ paddingLeft: '10px' }}></span>
        <b>{title}</b>
        <span style={{ float: 'right', color: colorGray500 }}>
          {timestamp ? moment(timestamp).fromNow() : ''}
        </span>
      </Text>
      <span style={{ paddingLeft: '30px' }}>
        <Text tag='span'>{message}</Text>
      </span>
      <span style={{ paddingTop: '5px' }}></span>
    </>
  );
};
